import React from 'react';
import { getSelectedState, GridHeaderSelectionChangeEvent, GridSelectionChangeEvent } from '@progress/kendo-react-grid';
import { getter } from "@progress/kendo-react-common";

const useKendoGridSelection = (dataItemKey: string, allData?:any[]) => {
    const [selectedState, setSelectedState] = React.useState<any>({});
    const idGetter = getter(dataItemKey);

    const handleSelectionChange = (event: GridSelectionChangeEvent) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey,
        });
        setSelectedState(newSelectedState);
    };

    const handleHeaderSelectionChange = React.useCallback(
        (event: GridHeaderSelectionChangeEvent) => {
            const checkboxElement: any = event.syntheticEvent.target;
            const checked = checkboxElement.checked;
            const newSelectedState = {} as any;
            const dataItems = allData ? allData : event.dataItems;
            dataItems.forEach((item) => {
                newSelectedState[idGetter(item)] = checked;
            });
            setSelectedState(newSelectedState);
        },
        [allData]
    );

    return { selectedState, setSelectedState, handleSelectionChange, handleHeaderSelectionChange };
};

export default useKendoGridSelection;
